import axios from 'axios'
import axiosInstance from './authAxios'
import { cryptoEncryptForWebOTP, decrypt, decrypt2 } from './decryption'



let baseUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_URL : process.env.REACT_APP_REMOTE_URL
let apiKey = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_API_KEY : process.env.REACT_APP_REMOTE_API_KEY

let encryptionKey = process.env.NODE_ENV === "development" ? process.env.REACT_APP_LOCAL_ENCRYPTION_KEY : process.env.REACT_APP_REMOTE_ENCRYPTION_KEY

//secured routes
export const getAllBuilding = async () => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/secured/building/all`)
        let decryptedData = decrypt(response.data.encryptedData, encryptionKey)
        return { data: JSON.parse(decryptedData) }
    } catch (error) {
        console.log("Error while getting the building list ", error)
    }
}

export const getAllBuildingAuthorized = async () => {
    try {
        return await axiosInstance.get(`${baseUrl}/admin/authorized-buildings`)
    } catch (error) {
        console.log("Error while getting all the authorized buildings ", error)
    }
}
export const getBuildings = async (venueName, campusIncludes) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/secured/building/get/venue`, { venueName, campusIncludes })
        let data = decrypt(response.data.encryptedData, encryptionKey)

        return { data: { data: JSON.parse(data), status: true } }
    } catch (error) {
        console.log("Error while gettign the venue ", error)
    }
}
export const getPatch = async (buildingId) => {
    try {
        let response = await axiosInstance.post(`/secured/patch/get`, { id: buildingId })
        let data = decrypt(response.data.encryptedData, encryptionKey)
        return { data: { patchData: JSON.parse(data), patchExist: true } }
    } catch (error) {
        console.log("Error while getting the patch data ", error)
    }
}
export const getPolyline = async (buildingId) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/secured/polyline`, { id: buildingId })
        let decryptedData = decrypt(response.data.encryptedData, encryptionKey)
        return { data: { polyline: JSON.parse(decryptedData), polylineExist: true } }
    } catch (error) {
        console.log("Error while getting the polyline data ", error)
    }
}
export const getEntries = async (buildingID) => {
    try {
        return await axiosInstance.post(`/secured/landmark/entries`, { id: buildingID })
    } catch (error) {
        console.log("Error while getting the entries", error)
    }
}
export const getLandmarksBySearch = async (post) => {
    try {
        let response = await axiosInstance.post(`/secured/landmarks/search/venues`, post)

        let data = decrypt(response.data.encryptedData, encryptionKey)
        return { data: { status: true, data: JSON.parse(data) } }
    } catch (error) {
        console.log("Error while getting the landmark search ", error)
    }
}

export const getLandmarksByFloor = async (post) => {
    try {
        return await axiosInstance.post(`/secured/landmarks/floor`, post)
    } catch (error) {
        console.log("Error while getting the landmarks by floor ", error)
    }
}

export const getMultibuildingRoute = async (post) => {
    try {
        return await axiosInstance.post(`/secured/mapbox/routing`, post)
    } catch (error) {
        console.log("Error while getting the route ", error)
    }
}

export const getLandmarks = async (buildingID) => {
    try {
        let response = await axiosInstance.post(`/secured/landmarks`, { id: buildingID })
        let decryptedData = decrypt(response.data.encryptedData, encryptionKey)
        return { data: { landmarks: JSON.parse(decryptedData), landmarkExist: true } }
    }
    catch (error) {
        console.log("Error while getting the landmarks data ", error)
    }
}
export const getIntrabuildingPath = async (post) => {
    try {
        return await axiosInstance.post(`/secured/path`, post)
    } catch (error) {
        console.log("Error while adding getting the path ", error)
    }
}
export const getInterbuildingPath = async (post) => {
    try {
        return await axios.post(`/secured/path`, post)
    } catch (error) {
        console.log("Error while getting the interbuilding path ", error)
    }
}
export const getWayfindingPath = async (post) => {
    try {
        let response = await axiosInstance.post(`/secured/indoor-path-finding`, post)
        let decryptedData = decrypt(response.data.encryptedData, encryptionKey)

        return { data: JSON.parse(decryptedData) }
    } catch (error) {
        console.log("Error while getting the wayfinding path ", error)
    }
}
export const getOutdoorPath = async (post) => {
    try {
        return await axiosInstance.post(`/secured/outdoor-path`, post)
    } catch (error) {
        console.log("Error while getting the outdoor path ", error)
    }
}

export const getOutDoorCampus = async (post) => {
    try {
        let response = await axiosInstance.post(`/secured/outdoor`, post)
        let data = decrypt(response.data.encryptedData, encryptionKey)
        return { data: { data: JSON.parse(data), status: true } }
    } catch (error) {
        console.log("Error while getting the outdoor campus ", error)
    }
}

export const getOutdoorWayfinding = async (post) => {
    try {
        return await axiosInstance.post('/secured/outdoor-wayfinding', post)
    } catch (error) {
        console.log("Error while getting the outdoor wayfinding ", error)
    }
}

export const getPolylineByFloor = async (post) => {
    try {
        return await axiosInstance.post('/secured/polyline/floor', post)
    } catch (error) {
        console.log("Error while getting the polyline data by floor ", error)
    }
}

export const getUserDetails = async (post) => {
    try {
        return await axiosInstance.post('/secured/user/get', post)
    } catch (error) {
        console.log("Error while getting the user details ", error)
    }
}



//auth routes


export const sendOtp = async (post) => {
    try {
        let token = await cryptoEncryptForWebOTP()
        // console.log(token, post)
        return await axios.post(`${baseUrl}/auth/web-otp-send`, post, {
            headers: { 'x-access-token': token }
        })
    } catch (error) {
        console.log("Error while sending the otp ", error)
    }
}

export const signup = async (post) => {
    try {
        return await axios.post(`${baseUrl}/auth/signup`, post)
    } catch (error) {
        console.log("Error while signing up the user ", error)
    }
}

export const signin = async (post, encryption) => {
    try {
        return await axios.post(`${baseUrl}/auth/signin`, post, {
            headers: encryption ? { "x-access-token": apiKey } : null
        })
    } catch (error) {
        console.log("Error while signing in ", error)
    }
}

export const signin2 = async (post, encryption) => {
    try {
        return await axios.post(`${baseUrl}/auth/signin2`, post, {
            headers: encryption ? { "x-access-token": apiKey } : null
        })
    } catch (error) {
        console.log("Error while signing in ", error)
        alert(error?.response?.data?.error)
    }
}
export const resetPassword = async (post) => {
    try {
        return await axiosInstance.post(`${baseUrl}/auth/reset-password`, post)
    } catch (error) {
        console.log("Error while reseting the password ", error)
    }
}

export const sendOtpForAccountVerify = async (post) => {
    try {
        let token = await cryptoEncryptForWebOTP()
        // console.log(token, post)
        return await axios.post(`${baseUrl}/auth/web-otp-username`, post, {
            headers: { 'x-access-token': token }
        })
    } catch (error) {
        console.log("Error while sending the otp for verification ", error)
        alert(error?.response?.data?.message)
    }
}

// export const sendOtpForAccountVerify

export const veryfyOtpAndGenerateToken = async (post) => {
    try {
        return await axios.post(`${baseUrl}/auth/otp/token`, post)
    } catch (error) {
        console.log("Error while getting the token")
        alert(error?.response?.data?.message)
    }
}

export const resetPasswordUsingToken = async (post) => {
    try {
        let creds = {
            username: post.username,
            password: post.password
        }
        const instance = axios.create({
            baseURL: baseUrl,
            // timeout: 1000,
            headers: { 'x-access-token': post.token }
        });
        return await instance.post(`/secured/user/reset-password`, creds, { headers: { 'Authorization': apiKey } })
    } catch (error) {
        console.log("Error while reseting the password")
        alert(error?.response?.data?.message)
    }
}


export const getGoogleUser = async () => {
    try {
        return await axios.get(`${baseUrl}/auth/login/success`, { withCredentials: true })

    } catch (error) {
        console.log("Error while getting google data ", error)
    }
}

export const getUsername = async (username, appId) => {
    try {
        let axiosInstance = axios.create({
            baseURL: baseUrl,
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY
            }
        })
        return await axiosInstance.post(`${baseUrl}/auth/username`, { username, appId })
    } catch (error) {
        console.log("Error while getting the username", error)
    }
}

export const logout = async (post) => {
    try {
        return await axios.delete(`${baseUrl}/api/refreshToken/delete`, post)
    } catch (error) {
        console.log("Error while logging out ", error)
    }
}

export const downloadFile = async (filePath, version) => {
    try {

        let response = await axiosInstance.get(`/admin/${filePath}/${version}`, {
            responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name
        link.setAttribute('download', `repo_${version}.zip`);
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    } catch (error) {
        console.log("Error while downloading the arr file ", error)
    }
}

export const getLandmarkByQr = async (code) => {
    try {
        return await axios.post(`${baseUrl}/api/qr`, { code })
    } catch (error) {
        console.log("Error while getting the landmark by code ", error)
    }
}

export const getQrDetail = async (code) => {
    try {
        return await axiosInstance.get(`/api/qr-detail/${code}`)
    } catch (error) {
        console.log("Error while getting the qr detail ", error)
    }
}

export const getLandmarkByNodeId = async (nodeId) => {
    try {
        return await axiosInstance.get(`https://maps.iwayplus.in/api/landmark-node/${nodeId}`)
    } catch (error) {
        console.log("Error while getting the landmarks by node ", error)
    }
}

export const getDeeplinks = async (landmarkId) => {
    try {
        return await axiosInstance.get(`/secured/deeplinks/${landmarkId}`)
    } catch (error) {
        console.log(error)
    }
}

export const getGeojsonData = async (venueName, floor) => {
    try {
        let response = await axiosInstance.get(`/secured/get-indoor-geojson-venue/${venueName}?floor=${floor}&encryptionVersion=v2`)

        let data = decrypt2(response.data.encryptedData, encryptionKey)
        return { data: JSON.parse(data)  }
    } catch (error) {
        console.log("Error while getting the geojson data ", error)
        alert(error?.response?.data?.message)
    }
}

export const getPathMaster = async (post) => {
    try {
        return await axiosInstance.post(`/secured/global-path-finding`, post)
    } catch (error) {
        console.log("Error while getting the path", error)
        alert(error?.response?.data?.message)
    }
}

export const getLandmark = async (post) => {
    try {
        return await axiosInstance.post(`/secured/landmark/get`, post)
    } catch (error) {
        console.log("Error while getting the landmark ", error)
        // alert(error?.response?.data?.message)
    }
}

export const getGlobalAnnotationElement = async (globalId) => {
    try {
        return await axiosInstance.get(`/secured/get-global-element/${globalId}`)
    } catch (error) {
        console.log("Error while getting global annotation ", error)
        alert(error?.response?.data?.message)
    }
}

export const savePolygonGlobal = async (globalId, post) => {
    try {
        return await axiosInstance.post(`/admin/update-polygon-global/${globalId}`, post)
    } catch (error) {
        console.log("Error while saving the global polygon element ", error)
        alert(error?.response?.data?.message)
    }
}

export const saveLandmark = async (landmarkId, post, setSaving) => {
    try {
        return await axiosInstance.put(`/admin/landmark/edit/${landmarkId}`, post)
    } catch (error) {
        setSaving(false)
        alert(error?.response?.data?.message)
        console.log("Error while saving the landmark ", error)
    }
}

export const saveScanRecord = async (post) => {
    try {
        return await axiosInstance.post(`/api/add-scan-record`, post)
    } catch (error) {
        console.log("Error while saving the scan record ", error)
    }
}

export const uploadFile = async (formData) => {
    try {
        return await axiosInstance.post(`/secured/upload`, formData)

    } catch (error) {
        console.log("Error while uploading the file ", error)
        alert(error?.response?.data?.message)
    }
}
export const uploadMedia = async (formData) => {
    try {
        return await axiosInstance.post(`/admin/upload-media`, formData)
    } catch (error) {
        console.log("Error while uploading the file ", error)
        alert(error?.response?.data?.message)
    }
}


export const generateApiKey = async () => {
    try {
        return await axiosInstance.get(`/admin/generate-api-key`)
    } catch (error) {
        console.log("Error while generating the api key ", error)
    }
}

export const getApiKey = async () => {
    try {
        return await axiosInstance.get(`/admin/get-api-key`)
    } catch (error) {
        console.log("Error while getting the api key ", error)
    }
}

export const deleteApiKey = async () => {
    try {
        return await axiosInstance.delete('/admin/delete-api-key')
    } catch (error) {
        console.log("Error while deleting the api key ", error)
    }
}

export const updateProfile = async (userId, post) => {
    try {
        return await axiosInstance.put(`/secured/user/update/${userId}`, post)
    } catch (error) {
        console.log("Error while updating the profile ", error)
        alert(error?.response?.data?.message)
    }
}

export const updateUsername = async (post) => {
    try {
        return await axiosInstance.put(`/secured/user/verify-otp-change-username`, post)
    } catch (error) {
        console.log("Error while updating username")
        alert(error?.response?.data?.message)
    }
}

export const chnagePassword = async (post) => {
    try {
        return await axiosInstance.post(`/secured/change-password`, post)
    } catch (error) {
        console.log("Error while changing the password ", error)
        alert(error?.response?.data?.message)
    }
}

export const changePlan = async (plan) => {
    try {
        return await axiosInstance.patch(`/admin/change-plan/${plan}`)
    } catch (error) {
        console.log("Error while changing the plan ", error)
    }
}

export const downloadBuildingIds = async (venueName) => {
    try {
        let response = await axiosInstance.get(`/secured/landmark-ids/${venueName}/download`, {
            responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name
        link.setAttribute('download', `${venueName}-landmarkIds.xlsx`);
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    } catch (error) {
        console.log("Error while downloading the building Ids ", error)
    }
}

export const getUsageData = async () => {
    try {
        return await axiosInstance.get(`/admin/plan-usage`)
    } catch (error) {
        console.log("Error while getting the usage ", error)
    }
}

export const getTimeSeriesOfApiKey = async (intervalSec, startTimeSec) => {
    try {
        return await axiosInstance.get(`/admin/apikey-timeseries/${intervalSec}/${startTimeSec}`)
    } catch (error) {
        console.log("Error while getting the timeseries ", error)
    }
}

export const getDocRoutes = async () => {
    try {
        return await axiosInstance.get(`/admin/doc-routes`)
    } catch (error) {
        console.log("Error while getting the doc routes ", error)
    }
}

export const getDocDetail = async (title) => {
    try {
        return await axiosInstance.get(`/admin/docs/${title}`)
    } catch (error) {
        console.log("Error while getting the doc detail ", error)
    }
}

export const assignQr = async (post) => {
    try {
        return await axiosInstance.post('/admin/assign-qr-console', post)
    }catch(error) {
        console.log("Error while assigning the qr ", error)
    }
}

export const deleteUserAccount = async (accessToken) => {
    try {
        return await axios.delete(`${baseUrl}/secured/user/delete`, {
            headers: {
                "x-access-token": accessToken
            }
        })
    }catch(error) {
        console.log("Error while deleting the account ", error)
        alert(error?.response?.data?.error)
    }
}

export const getAppIds = async () => {
    try {
        return await axiosInstance.get('/admin/app-ids-venue')
    }catch(error) {
        console.log("Error while getting the app ids ", error)
    }
}




